import { useState, useEffect } from 'react'
import axios from 'axios'

const CalculatorData = (location) => {
	// input values for the api request
	const [inputValue, setInputValue] = useState({
		loanPurposeId: '1',
		principal: '10,000',
		termMonths: 0,
	})

	const [validationError, setValidationError] = useState('')
	const [resultsState, setResultsState] = useState([])

	const validateInputs = () => {
		setValidationError('')

		const { loanPurposeId, principal, termMonths } = inputValue

		// Validate the Length of Loan
		if (!termMonths) {
			setResultsState([])
			setValidationError(`Please select the Length of Loan`)
			return
		}

		// Validate the Treatment Type
		let minLoanAmount = 2500
		let maxLoanAmount = 75000

		switch (loanPurposeId) {
			case '1':
				minLoanAmount = 2500
				maxLoanAmount = 75000
				break
			case '3':
				minLoanAmount = 2500
				maxLoanAmount = 25000
				break
			default:
				setValidationError(`Please select the Treatment Type`)
				return
		}

		// Validate principal
		const principalAmount = principal.replaceAll(',', '')
		if (
			!principalAmount ||
			principalAmount < minLoanAmount ||
			principalAmount > maxLoanAmount
		) {
			setValidationError(
				`Please enter a loan amount between $${minLoanAmount} and $${maxLoanAmount}`,
			)
			return
		}

		calculateResults()
	}

	const onChange = (name, value) => {
		if (name === 'principal') {
			// convert value to a number to compare the min/max values
			const loanAmount = String(value).replaceAll(',', '')
			// format the value if there is a loan amount
			if (loanAmount) {
				value = parseInt(loanAmount).toLocaleString('en-US')
			}
		}
		setInputValue({ ...inputValue, [name]: value })
	}

	const calculateResults = async () => {
		const { principal, loanPurposeId, termMonths } = inputValue
		try {
			const response = await axios.post('/calculator', {
				loan_purpose_id: loanPurposeId,
				principal: principal.replace(/\D/g, ''),
				term_months: termMonths,
				location: location,
			})

			setResultsState(response.data)
		} catch (error) {
			setValidationError(error.response.data.error)
			setResultsState([])
		}
	}

	useEffect(() => {
		validateInputs()
	}, [inputValue])

	return {
		onChange,
		error: validationError,
		calculatedResults: resultsState,
		...inputValue,
	}
}

export default CalculatorData
